<template>
  <section class="outreach-stasge-segments">
    <list-tag :tags="stagesData" :type="OUT_REACH_TAG_TYPE.STAGE" />
  </section>
</template>

<script>
import ListTag from "../TagComponents/ListTag.vue";
import { OUT_REACH_TAG_TYPE } from "@/store/modules/outreach/types";

export default {
  components: {
    ListTag,
  },
  data() {
    return {
      OUT_REACH_TAG_TYPE,
    };
  },
  computed: {
    stagesData() {
      return this.$store.state.outreach.stages.data || [];
    },
  },
};
</script>
